import React, { useState, Children, Component } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { MINT_NAVIGATION, MINT_BRAND, getIconComponent, NavItem } from '../../config/navigation';
import { ChevronDownIcon, ChevronRightIcon } from 'lucide-react';
export function Layout() {
  const location = useLocation();
  const [expandedItems, setExpandedItems] = useState<Set<string>>(new Set(['Liquidity Desk']));
  const toggleExpanded = (name: string) => {
    const newExpanded = new Set(expandedItems);
    if (newExpanded.has(name)) {
      newExpanded.delete(name);
    } else {
      newExpanded.add(name);
    }
    setExpandedItems(newExpanded);
  };
  const renderNavItem = (item: NavItem, level: number = 0) => {
    const hasChildren = item.children && item.children.length > 0;
    const isExpanded = expandedItems.has(item.name);
    const isActive = item.path && location.pathname === item.path;
    if (hasChildren) {
      return <div key={item.name} data-id="element-215">
          <button onClick={() => toggleExpanded(item.name)} className="w-full flex items-center justify-between px-4 py-2.5 text-sm text-gray-300 hover:bg-gray-700 hover:text-white" data-id="element-216">
            <div className="flex items-center" data-id="element-217">
              {item.icon && <span className="mr-3" data-id="element-218">{getIconComponent(item.icon)}</span>}
              <span data-id="element-219">{item.name}</span>
            </div>
            {isExpanded ? <ChevronDownIcon size={16} data-id="element-220" /> : <ChevronRightIcon size={16} data-id="element-221" />}
          </button>
          {isExpanded && <div className="bg-gray-900" data-id="element-222">
              {item.children?.map(child => renderNavItem(child, level + 1))}
            </div>}
        </div>;
    }
    if (item.path) {
      return <Link key={item.name} to={item.path} className={`flex items-center px-4 py-2.5 text-sm ${level > 0 ? 'pl-12' : ''} ${isActive ? 'bg-gray-700 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'}`} data-id="element-223">
          {item.icon && <span className="mr-3" data-id="element-224">{getIconComponent(item.icon)}</span>}
          {item.name}
        </Link>;
    }
    return null;
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-225">
      {/* Sidebar */}
      <div className="w-56 bg-gray-800 text-white flex flex-col flex-shrink-0" data-id="element-226">
        <div className="p-4 border-b border-gray-700" data-id="element-227">
          <h1 className="text-xl font-bold" data-id="element-228">{MINT_BRAND.name}</h1>
        </div>
        <nav className="flex-1 overflow-y-auto py-4" data-id="element-229">
          <ul className="space-y-1" data-id="element-230">
            {MINT_NAVIGATION.map(item => renderNavItem(item))}
          </ul>
        </nav>
        <div className="p-4 border-t border-gray-700 text-xs text-gray-400" data-id="element-231">
          <div data-id="element-232">
            {MINT_BRAND.tagline} {MINT_BRAND.version}
          </div>
        </div>
      </div>
      {/* Main Content */}
      <main className="flex-1 overflow-auto px-8 py-8 w-full" data-id="element-233">
        <Outlet data-id="element-234" />
      </main>
    </div>;
}